module.exports = __webpack_public_path__ + "static/media/daimler-wharf-1.1abd7863.jpg";